import { z } from 'zod';
import { LessonSkillCategoriesEnum, SportsEnum } from 'types/generated/client';
import { ReflectionFormType } from './props';

const reflectionFormSchema = z
  .object({
    currentSkills: z
      .array(z.string())
      .min(1, 'Please select at least one skill')
      .max(3, 'Maximum 3 skills can be selected'),
    futureSkills: z
      .array(z.string())
      .min(1, 'Please select at least one skill')
      .max(3, 'Maximum 3 skills can be selected'),
    assignmentSkills: z.array(z.string()).max(3, 'Maximum 3 skills can be selected').optional(),
    completedCategoryOrSport: z
      .enum([
        LessonSkillCategoriesEnum.P4,
        LessonSkillCategoriesEnum.Quatro,
        SportsEnum.Pickleball,
        SportsEnum.Tennis,
        SportsEnum.PlatformTennis,
        SportsEnum.Padel,
      ])
      .nullable(),
    upcomingCategoryOrSport: z
      .enum([
        LessonSkillCategoriesEnum.P4,
        LessonSkillCategoriesEnum.Quatro,
        SportsEnum.Pickleball,
        SportsEnum.Tennis,
        SportsEnum.PlatformTennis,
        SportsEnum.Padel,
      ])
      .nullable(),
    assignmentCategoryOrSport: z
      .enum([
        LessonSkillCategoriesEnum.P4,
        LessonSkillCategoriesEnum.Quatro,
        SportsEnum.Pickleball,
        SportsEnum.Tennis,
        SportsEnum.PlatformTennis,
        SportsEnum.Padel,
      ])
      .nullable(),
    details: z.string().optional(),
    lessonReflectionFiles: z.array(z.any()).optional(),
  })
  .refine(
    (data) => {
      return !!data.details || !!data.lessonReflectionFiles?.length;
    },
    {
      message:
        'Please provide either a text description or media (either any file or voice recording)',
      path: ['details'],
    },
  );

export { reflectionFormSchema };

export const reflecionFormDefaultValues: ReflectionFormType = {
  currentSkills: [],
  futureSkills: [],
  assignmentSkills: [],
  completedCategoryOrSport: null,
  assignmentCategoryOrSport: null,
  upcomingCategoryOrSport: null,
  details: '',
};
